import {
  EVENT_TYPES,
  type BuiltInDispatchEntry
} from '@care-portals/api-interfaces';

/**
 * AutoPilotRx's `CreateOrder` (CAR-2333) — submits an order to AutoPilotRx on
 * `order.awaiting_shipment` without a per-org Workflow blueprint, the same mechanism TMC uses
 * (docs/builtin-dispatch.md).
 *
 * `triggerFilter` — TBD: confirm the exact `assignedPharmacy.name` string configured for
 * AutoPilotRx in this org's pharmacies collection before enabling `isAutoPilotRxEnabled`.
 */
export const AutoPilotRxBuiltInDispatch: BuiltInDispatchEntry[] = [
  {
    id: 'autopilotrx-create-order',
    label: 'AutoPilotRx — Create Order',
    triggerEvent: EVENT_TYPES.awaiting_shipment,
    triggerFilter: { 'assignedPharmacy.name': 'AutoPilotRx Pharmacy' },
    middlewareHandler: 'autopilotrx',
    functionName: 'CreateOrder',
    integrationFlag: 'isAutoPilotRxEnabled',
    passPayload: true
  }
];
